import { Component, Input, SimpleChanges } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ContactGroupService } from 'src/app/private/services/contact-group.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-dialing-group-list',
  imports: [SharedModule],
  templateUrl: './dialing-group-list.component.html',
  styleUrl: './dialing-group-list.component.scss',
  providers: [ConfirmationService]
})
export class DialingGroupListComponent {


  dataSource: any[] = [];
  @Input() currentSelectedContactGroupID: string | null = null;

  @Input() toggleFlag: boolean = false;

  totalRecords: number = 0;
  rows: number = 50; // Default page size
  pageSizeOptions = [5, 10, 20, 50];
  loading: boolean = false;

  displayedColumns: Array<{ field: string, header: string, type: string }> = [];
  dataToEdit: any = {};
  isDeleteContact: boolean = false;
  selectedContact: any = null;
  btnLoading: boolean = false;

  constructor(
    private api: ContactGroupService,
    private localStorage: LocalStorageService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit(): void {
    this.setDisplayColumns();
    this.loadData({ first: 0, rows: this.rows });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['currentSelectedContactGroupID']?.currentValue
      || changes['toggleFlag']?.currentValue
    ) {
      this.loadData({ first: 0, rows: this.rows });
    }
  }

  setDisplayColumns(): void {
    this.displayedColumns = [
      { field: 'name', header: 'Contact Name', type: 'contact_name' },
      { field: 'mobile_number', header: 'Mobile Number', type: 'phone' },
      { field: 'email', header: 'Email', type: 'email' },
      // { field: 'call_status', header: 'Call Status', type: 'call_status' },
      // { field: 'status', header: 'Status', type: 'status' },
      { field: 'created_at', header: 'Created On', type: 'created_at' },
      { field: 'actions', header: 'Actions', type: 'actions' },
    ];
  }

  loadData(event?: any) {


    if (!this.currentSelectedContactGroupID) {
      return;
    }

    // const payload = {
    //   where: {
    //     organization_id: this.localStorage.getOrganizationId(),
    //     contact_group_id: this.currentSelectedContactGroupID
    //   },
    //   filter: null,
    //   page,
    //   limit: size,
    //   order: {
    //     col: '"contact_group_list"."updatedAt"',
    //     dir: 'DESC'
    //   }
    // };

    this.loading = true;

    if (!this.currentSelectedContactGroupID) {
      return;
    }

    const payload = {
      organizationId: this.localStorage.getOrganizationId(),
      campusId: this.localStorage.getCampusId(), // make sure you have this
      groupId: this.currentSelectedContactGroupID,
    }

    this.api.getAllContactGroupListFromDynamoDB(payload).subscribe({
      next: (data) => {
        this.dataSource = data.contacts || [];
        this.totalRecords = data.total_contacts || 0;
        this.loading = false;
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load contact groups.' });
        this.loading = false;
      },
    });
  }

  setTemplateEditData(template: any): void {
    this.dataToEdit = template;
  }

  getFullName(user: any): string {
    return [user?.prefix, user?.first_name, user?.last_name]
      .filter(Boolean)
      .join(' ') || 'N/A';
  }


  deleteContactPopUp(contact: any) {
    this.selectedContact = contact;
    this.isDeleteContact = true;
  }


  deleteContact() {
    if (!this.selectedContact || !this.currentSelectedContactGroupID) {
      return;
    }

    this.btnLoading = true;

    const payload = {
      organizationId: this.localStorage.getOrganizationId(),
      campusId: this.localStorage.getCampusId(),
      groupId: this.currentSelectedContactGroupID,
      contactId: this.selectedContact.contact_id
    }

    this.api.deleteContactsFromGroup(payload).subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Contact deleted successfully.' });
        this.loadData({ first: 0, rows: this.rows });
        this.btnLoading = false;
        this.isDeleteContact = false;
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to delete contact.' });
        this.btnLoading = false;
      }
    });
  }
}